<template>
  <Form ref="form" as="div">
    <div class="flow__body row container" id="editPowerOfAttorney" v-cloak>
      <div class="small-12 medium-12 large-6 columns">
        <h1 v-html="model.Content.LabelTitle" />
        <span v-html="model.Content.TextDisclaimer" />

        <section>
          <div class="row columns">
            <h2 v-html="model.Content.LabelYouHaveGivenPOATo" />
            <p v-html="model.Data.Name" />
          </div>

          <div class="row medium-unstack">
            <div class="columns" v-html="model.Content.TooltipThePersonHasAccessTo" />
            <div class="columns">
              <fieldset class="radio-inline">
                <template v-for="accessLevel in model.Content.AccessLevels">
                  <div>
                    <!-- Disabling on accesslevel 1000002 is temporary and should be removed when read access has been implemented-->
                    <input
                      type="radio"
                      class="poa-scenario-a"
                      v-model="model.Data.AccessLevel"
                      name="accessLevel"
                      :value="accessLevel.Id"
                      :id="accessLevel.Id"
                      :disabled="deletePOA || accessLevel.Id === 1000001"
                      @change="
                        compareToInitial();
                        resetConditions();
                      "
                    />
                    <label :for="accessLevel.Id" v-html="accessLevel.Description" />
                  </div>
                </template>
              </fieldset>
            </div>
          </div>

          <div class="row medium-unstack">
            <div class="small-12 medium-6 columns">
              <div class="checkbox-inline">
                <input
                  id="deletePowerOfAttorney"
                  v-model="deletePOA"
                  name="delete"
                  type="checkbox"
                  @change="
                    validateAll();
                    compareToInitial();
                    resetConditions();
                  "
                />
                <label for="deletePowerOfAttorney">
                  <strong v-html="model.Content.LabelDeletePOA" />
                </label>
              </div>
            </div>
          </div>

          <div class="row medium-unstack">
            <div class="small-12 medium-8 columns">
              <div v-html="model.Content.TooltipPOACPR" />
              <div class="row" v-cloak>
                <div class="small-7 columns">
                  <input
                    type="text"
                    name="cpr_number"
                    v-model="model.Data.SocialSecurityNumber"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row medium-unstack">
            <div class="small-12 medium-8 columns">
              <div v-html="model.Content.TooltipPOAMail" />
              <input type="email" v-model="model.Data.Email" name="email" disabled />

              <div class="checkbox-inline">
                <Field
                  id="acceptAccessTerms"
                  v-model="acceptAccessTerms"
                  label="vilkårene"
                  name="acceptAccessTerms"
                  type="checkbox"
                  :rules="'required'"
                  :disabled="deletePOA || !changeIsMade"
                />
                <label for="acceptAccessTerms">
                  <strong v-html="model.Content.LocalContent.LabelAcceptTermsTitle" />
                </label>
                <div
                  v-if="model.Data.AccessLevel == '@((int)@AccessLevelEnum.Full)'"
                  v-html="model.Content.LocalContent.TextAcceptTermsReadAndWrite"
                />
                <div
                  v-if="model.Data.AccessLevel == '@((int)@AccessLevelEnum.View)'"
                  v-html="model.Content.LocalContent.TextAcceptTermsRead"
                />
              </div>
              <ValidationError name="acceptAccessTerms" data-test-error="acceptAccessTerms" />

              <h3 v-html="model.Content.LocalContent.LabelGDPRTitle" />
              <span v-html="model.Content.LocalContent.TextGDPRDescription" />
            </div>
          </div>

          <div class="row push-up">
            <div class="small-12 medium-6 columns">
              <button
                @click="redirect"
                class="button secondary"
                v-html="model.Content.LabelCancel"
              />
            </div>
            <div class="small-12 medium-6 columns">
              <button @click="submitForm" class="button" :disabled="!changeIsMade || saving">
                <span v-html="model.Content.LabelSaveChanges" />
                <div class="spinner spinner-button" v-show="saving" />
              </button>
            </div>
          </div>
        </section>
      </div>

      <transition name="modal">
        <v-modal :is-open="showModalDelete" @close="closeModalAndRedirect">
          <template #title>
            <h3 v-html="model.Content.LabelYourPOAIsDeleted" />
          </template>

          <template #content>
            <span v-html="model.Content.TextYourPOAIsDeleted" />
            <a
              @click="closeModalAndRedirect"
              class="button large close-modal"
              v-html="model.Content.LabelCloseModalTekst"
            />
          </template>
          <template #footer />
        </v-modal>
      </transition>

      <transition name="modal">
        <v-modal :is-open="showModalEdit" @close="closeModalAndRedirect">
          <template #title>
            <h3 v-html="model.Content.LabelYourPOAIsChanged" />
          </template>
          <template #content>
            <span v-html="model.Content.TextYourPOAIsChanged" />
            <a
              @click="closeModalAndRedirect"
              class="button large close-modal"
              v-html="model.Content.LabelCloseModalTekst"
            />
          </template>
          <template #footer />
        </v-modal>
      </transition>

      <transition name="modal">
        <v-modal :is-open="showModalFail" @close="closeModalAndStay">
          <template #title>
            <h3 v-html="model.Content.LocalContent.LabelUnknownError" />
          </template>
          <template #content>
            <span v-html="model.Content.LocalContent.TextUnknownError" />
            <a
              @click="closeModalAndStay"
              class="button large close-modal"
              v-html="model.Content.LabelCloseModalTekst"
            />
          </template>
          <template #footer />
        </v-modal>
      </transition>
    </div>
  </Form>
</template>
<script>
import { defineComponent } from 'vue';
import axios from 'axios';
import Utility from '@/common/UtilityFunctions.js';

import { Form } from 'vee-validate';

export default {
  name: 'EditPowerOfAttorney',
  components: {
    Form
  },
  props: {
    model: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      deletePOA: false,
      changeIsMade: false,
      acceptAccessTerms: false,
      saving: false,
      showModalEdit: false,
      showModalDelete: false,
      showModalFail: false,
      initialValues: {}
    };
  },
  created() {
    this.model.Content.AccessLevels[0].Text = this.model.Content.TextAcceptTermsRead;

    this.model.Content.AccessLevels[1].Text = this.model.Content.TextAcceptTermsReadAndWrite;

    this.initialValues.deletePOA = this.deletePOA;
    this.initialValues.accessLevel = this.model.Data.AccessLevel;
  },
  methods: {
    submitForm() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.saving = true;
          axios
            .post(Utility.constants().API.power_of_attorney_update, {
              GivenToId: this.model.Data.ContactId,
              AccessLevel: this.model.Data.AccessLevel,
              AcceptAccessTerms: this.acceptAccessTerms,
              Delete: this.deletePOA
            })
            .then(() => {
              this.saving = false;
              this.showModalDelete = this.deletePOA ? true : true;
            })
            .catch(() => {
              this.saving = false;
              this.showModalFail = true;
            });
        }
      });
    },
    updateQuery(params) {
      this.query = params;
    },
    isEmpty(params) {
      if (params) {
        this.query = null;
      }
    },
    redirect() {
      console.log('RedirectUrl', this.model.RedirectUrl);
      window.location = this.model.RedirectUrl + '#powerOfAttorney';
    },
    closeModalAndRedirect() {
      console.log('Content.RedirectUrl', this.model.Content.RedirectUrl);
      window.location = this.model.Content.RedirectUrl + '#powerOfAttorney';
    },
    closeModalAndStay() {
      this.showModalFail = false;
    },
    validateAll() {
      if (this.deletePOA) {
        $("input[name='email']").removeClass('invalid');
      }
    },
    compareToInitial() {
      if (this.model.Data.AccessLevel == this.initialValues.accessLevel && !this.deletePOA) {
        this.changeIsMade = false;
      } else {
        this.changeIsMade = true;
      }
    },
    resetConditions() {
      this.acceptAccessTerms = false;
    }
  }
};
</script>
